import React from 'react'

import bem from '../utils/bem'
import Button from './button'
import DeleteIcon from './delete2-icon'
import {ObjectContext} from './object-store'
import {useDelete} from './object-store'
import {useFocusBlurSaveField} from './object-store'
import {useSaveField} from './object-store'
import WrappingButtons from './wrapping-buttons'
import './wrktset-editor.scss'
import {useSaves} from './object-store'
import {useSave} from './object-store'
import genId from '../utils/gen_id'


export default function WrktsetEditor({wrktset, ...props}) {
    return <ObjectContext model="wrktset" id={wrktset.id}>
        <Wrktset_ wrktset={wrktset} {...props} />
    </ObjectContext>
}

function Wrktset_({
    wrktset,
    onMoveUp,
    onMoveDown,
    onActivate,
    active,
    history,
    exerciseNote,
    onPrepareExecutor,
    onUpdateStatus,
    following,
    editMode,
    selected,
    onToggleSelect,
}) {
    const save = useSaves()
    const exerciseProps = useFocusBlurSaveField('exercise')
    const [weight, setWeight_] = useSaveField('weight')
    const weightProps = useFocusBlurSaveField('weight', {id: 'w', onBlur: next => {
        if (!following) {return}
        if (next == weight) {return}
        save('wrktset', following.map(f => {
            return {id: f.id, weight: next, count: countProps.value}
        }))
    }})
    const [count, setCount_] = useSaveField('count')
    const countProps = useFocusBlurSaveField('count', {onBlur: next => {
        if (!following) {return}
        if (next == count) {return}
        save('wrktset', following.map(f => {
            return {id: f.id, weight: weightProps.value, count: next}
        }))
    }})
    const statusProps = useSaveField('status')
    const rankProps = useFocusBlurSaveField('rank')
    const remove = useDelete()

    function increaseCount() {
        setCount(prev => parseInt(prev, 10) + 1)

    }

    function decreaseCount() {
        setCount(prev => parseInt(prev, 10) - 1)
    }

    function setWeight(f) {
        setWeight_(prev => {
            const next = f(prev)
            if (following) {
                save('wrktset', following.map(f => ({id: f.id, weight: next, count: countProps.value})))
            } else {
                save('wrktset', [{id: wrktset.id, weight: next}])
            }
            return next
        })
    }

    function setCount(f) {
        setCount_(prev => {
            const next = f(prev)
            if (following) {
                save('wrktset', following.map(f => ({id: f.id, weight: weightProps.value, count: next})))
            } else {
                save('wrktset', [{id: wrktset.id, count: next}])
            }
            return next
        })
    }

    const bDisabled = statusProps[0] === 'done' && following

    return <div
        className={bem("wrktset-editor").m({})}
        onFocus={event => {
            if (editMode) return
            if (event.target && event.target.classList.contains('check-circle')) {
                return
            }
            onActivate(wrktset.id)
        }}
        onClick={event => {
            if (editMode) {
                onToggleSelect && onToggleSelect(wrktset.id)
                return
            }
            if (event.target && event.target.classList.contains('check-circle')) {
                return
            }
            onActivate(wrktset.id)
        }}
    >
        <div className="wrktset-editor__main">
            <div className="wrktset-editor__main__inputs">
                <WrappingButtons
                    onTopClick={() => onMoveUp(wrktset)}
                    onBottomClick={() => onMoveDown(wrktset)}
                    grow
                    active={active}
                    disabled={bDisabled}
                    extraClassName="wrktset-editor__main__inputs__main"
                >
                    <input
                        {...exerciseProps}
                        className="in-l"
                    />
                </WrappingButtons>
                <WrappingButtons
                    onTopClick={() => increaseWeight(setWeight)}
                    onBottomClick={() => decreaseWeight(setWeight)}
                    active={active}
                    extraClassName="wrktset-editor__main__inputs__side"
                    disabled={bDisabled}
                >
                    <input
                        {...weightProps}
                        className="short-input in-m"
                    />
                </WrappingButtons>
                <WrappingButtons
                    onTopClick={increaseCount}
                    onBottomClick={decreaseCount}
                    active={active}
                    extraClassName="wrktset-editor__main__inputs__side"
                    disabled={bDisabled}
                >
                    <input
                        {...countProps}
                        className="short-input in-r"
                    />
                </WrappingButtons>
            </div>
            <div className="wrktset-editor__right">
                <input
                    type="checkbox"
                    checked={selected}
                    readOnly
                    className={bem("check-box").m({hidden: !editMode})}
                />
                <div
                    className={bem("check-circle").m({hidden: editMode, checked: statusProps[0] === 'done'})}
                    onClick={() => statusProps[1](prev => {
                        const next = prev === 'done' ? 'todo' : 'done'
                        setTimeout(() => onUpdateStatus({...wrktset, status: next}))
                        return next
                    })}
                />
            </div>
            <input
                type="hidden"
                name="status"
                value={statusProps[0]}
            />
        </div>
        {active ?
            <ExerciseNote exerciseNote={exerciseNote} exercise={exerciseProps.value} />
            : null
        }
        {history && exerciseProps.value && active ?
            <History history={history} wrktset={wrktset} />
            : null
        }
    </div>
}


function ExerciseNote({exerciseNote, exercise}) {
    const save = useSave()
    const noteIdRef = React.useRef(exerciseNote?.id || genId())
    const [value, setValue] = React.useState(exerciseNote?.note || '')
    const valueRef = React.useRef(value)
    const exerciseRef = React.useRef(exercise)
    const textareaRef = React.useRef()

    React.useEffect(() => {
        if (exerciseNote) {
            noteIdRef.current = exerciseNote.id
            setValue(exerciseNote.note || '')
            valueRef.current = exerciseNote.note || ''
        }
    }, [exerciseNote?.id])

    React.useEffect(() => {
        exerciseRef.current = exercise
    }, [exercise])

    function autoResize(el) {
        el.style.height = 'auto'
        el.style.height = el.scrollHeight + 'px'
    }

    React.useEffect(() => {
        if (textareaRef.current) {
            autoResize(textareaRef.current)
        }
    }, [value])

    React.useEffect(() => {
        return () => {
            save('note', {id: noteIdRef.current, exercise: exerciseRef.current, note: valueRef.current})
        }
    }, [])

    function handleChange(e) {
        valueRef.current = e.target.value
        setValue(e.target.value)
        autoResize(e.target)
    }

    return <textarea
        ref={textareaRef}
        className="wrktset-editor__note"
        value={value}
        onChange={handleChange}
        placeholder="Note..."
        rows={1}
    />
}


function History({history, wrktset}) {
    let prevDay = null
    history = history.filter(s => s.day !== wrktset.day)
    if (history.length === 0) {return null}
    return <ol className="wrktset-editor__history">
        {history.map(s => {
            const firstInDay = prevDay !== s.day
            prevDay = s.day
            return <li key={s.id}>
                {firstInDay ?
                    <div className="wrktset-editor__history__header">
                        <a target="_blank" href={"#log&day=" + s.day}>
                            {s.day} {s.title}
                        </a>
                    </div>
                    : null
                }
                <div>
                    <span>{s.weight}</span> <span>{s.count}</span>
                </div>
            </li>
        })}
    </ol>
}


export function increaseWeight(setWeight) {
    setWeight(prev => {
        if (!prev) {return '1kg'}
        if (prev === 'B') {
            return '-'
        }
        if ((parseInt(prev, 10) + 'kg') != prev) {
            return prev
        }
        return (parseInt(prev, 10) + 1) + 'kg'
    })
}

export function decreaseWeight(setWeight) {
    setWeight(prev => {
        if (!prev) {return '1kg'}
        if (prev === '-') {
            return 'B'
        }
        if ((parseInt(prev, 10) + 'kg') != prev) {
            return prev
        }
        return (parseInt(prev, 10) - 1) + 'kg'
    })
}